export default __webpack_public_path__ + "static/media/manWithPhoneLaughing.459633bf.jpg";